<template>
  <div name="AdminProgramlist">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">節目列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">影音</li>
              <li class="breadcrumb-item active">節目列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-programme" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-8">
            列表排序方式與頁面「
            <router-link tag="a" target="_blank" :to="{name:'VideoIndex'}">影音主頁 — 我們的節目橫向捲軸</router-link>」及「
            <router-link tag="a" target="_blank" :to="{name:'MoreProgram'}">我們的節目 — 按熱門程度排序</router-link>」關聯
          </div>
          <div class="col-sm-4">
            <router-link :to="{name:'EditProgram'}">
              <el-button size="primary">
                <i class="nav-icon fas fa-plus fa-sm mr-1"></i> 新增節目
              </el-button>
            </router-link>
            <el-button size="primary" @click="SortByBrowse()">
              <i class="nav-icon fas fa-sort-amount-down fa-sm mr-1"></i> 重設排序 (按總瀏覽量)
            </el-button>
            <el-button size="primary" @click="sortout()">
              <i class="nav-icon fas fa-save fa-sm mr-1"></i> 保存當前排序
            </el-button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table :data="programlist" border row-key="id" v-loading="mloading">
                  <el-table-column width="40">
                    <template slot-scope="scope">
                      <i class="fas fa-arrows-alt-v handle"></i>
                    </template>
                  </el-table-column>
                  <el-table-column label="節目" width="500">
                    <template slot-scope="scope">
                      <div class="b-programme-block mr-2 clearfix">
                        <div class="b-programme-thumbnail">
                          <div class="b-programme-responsive">
                            <div class="b-programme-sizer">
                              <div
                                class="b-programme-image"
                                :style="{backgroundImage: 'url('+`${scope.row.sgL_LogImage}`+')'}"
                              ></div>
                            </div>
                          </div>
                          <div class="b-episode">
                            <span>共 {{scope.row.movieCount}} 集</span>
                          </div>
                        </div>
                      </div>
                      <span class="b-title">
                        <a href>{{scope.row.sgL_Program_Name}}</a>
                      </span>
                      <span class="b-intro">{{scope.row.sgL_Program_NameDesc}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="programType" label="類型">
                    <template slot-scope="scope">
                      <span
                        class="typestyle"
                        v-for="(item,index) in scope.row.sgL_Type_List"
                        v-bind:key="index"
                      >
                        <router-link :to="{name:'programType'}">{{item.sgL_Program_Name}}</router-link>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sgL_UpdateTimeF" label="影片最後更新時間"></el-table-column>
                  <el-table-column prop="browse_Count" label="總瀏覽量"></el-table-column>
                  <!-- <el-table-column prop="praise_Count" label="總讚好"></el-table-column>
                  <el-table-column prop="collect_Count" label="總收藏"></el-table-column> -->
                  <el-table-column prop="share_Count" label="總分享"></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" type="primary" @click="EditProgram(scope.row.id)">編輯</el-button>
                      <el-popconfirm title="  " @onConfirm="DeleteProgram(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import Sortable from "../../../node_modules/sortablejs";
import { Message } from "element-ui";
export default {
  name: "AdminProgramlist",
  data() {
    return {
      mloading: true,
      data: [],
      sortList: []
    };
  },
  beforeMount() {
    let admin = this.$store.getters.getAdminUser;
    let permission = this.$store.getters.getPermission;
    if (admin == null || permission.Istoken == false) {
      this.$router.push("/login");
    }
  },
  computed: {
    programlist() {
      return this.data;
    }
  },
  created() {
    this.getProgramList();
  },
  watch: {
    data(newvalue, oldvalue) {
      if (newvalue.length > 0) {
        this.mloading = false;
      }
    }
  },
  mounted() {
    this.rowDrop();
  },
  methods: {
    //获取数据
    async getProgramList() {
      let params = { SGL_Program_Type: 0, MaxResultCount: 50 }; //0代表查询节目列表  1查询节目类型列表
      this.$api.VideoApi.GetAdminProgramList(params).then(result => {
        this.data = result.data.result.items;
        this.mloading = false;
        this.$store.dispatch("writeTvcategory", this.data);
      });
    },
    EditProgram(id) {
      this.$router.push({ name: "EditProgram", query: { Id: id } });
    },
    DeleteProgram(id) {
      let params = {
        Id: id
      };
      this.$api.VideoApi.DeleteAdminProgram(params).then(res => {
        if (res.data.success) {
          Message({
            type: "success",
            message: "刪除成功"
          });
        } else {
          Message({
            type: "error",
            message: res.data.error.message
          });
        }
        this.getProgramList();
      });
    },
    //保存排序
    sortout() {
      this.sortList = [];
      this.data.map((item, index) => {
        //拖拽时改变了data数据顺序、所以直接取index就可以取到排序值
        let sort = { id: item.id, sortID: index };
        this.sortList.push(sort);
      });
      this.$api.VideoApi.SortAdminProgram(this.sortList).then(res => {
        if (res.data.success) {
          Message({ type: "success", message: "已保存" });
        } else {
          Message({ type: "error", message: res.data.error.message });
        }
      });
    },
    SortByBrowse() {
      let params = { OrderByType: 1, SGL_Program_Type: 0 };
      this.$api.VideoApi.OrderByAdminBrowse(params).then(res => {
        if (res.data.success) {
          Message({ type: "success", message: this.$t('message.operatesuccessfully') });
          this.getProgramList();
        }
      });
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      let _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.data.splice(oldIndex, 1)[0]; //删除
          _this.data.splice(newIndex, 0, currRow); //插入
        }
      });
    }
  }
};
</script>
<style scoped>
.typestyle {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminVideo/AdminProgramList.vue